import type { AxiosError } from "axios";
import { RequireProperty } from "@/types";
import WebshareApi from "..";

export interface IAuthParams {
  email: string;
  password: string;
  recaptcha: string;
  tos_accepted?: boolean;
  anonymous_user_token?: string;
  marketing_email_accepted?: boolean;
}

export interface ISocialParams {
  provider: string;
  code: string;
  redirect_uri?: string;
  tos_accepted: boolean;
}

export interface IResetPasswordParams {
  email: string;
  recaptcha: string;
}

export interface ICompleteResetPasswordParams {
  password: string;
  password_reset_token: string;
  recaptcha: string;
}

export type ResponseErrorType<T extends unknown> = RequireProperty<
  AxiosError<T>,
  "response"
>;

export type ChangeEmailRequestType = {
  new_email: string;
  password: string;
};

export type ChangeEmailConfirmType = {
  confirmation_code: string;
};

export type ChangePasswordParamsType = {
  password: string;
  new_password: string;
};

export const register = (params: IAuthParams) =>
  WebshareApi.post<{ token: string; logged_in_existing_user: boolean }>(
    "/register/",
    { ...params }
  );

export const social = ({
  endpoint,
  params,
}: {
  endpoint: "login" | "register";
  params: ISocialParams;
}) =>
  WebshareApi.post<{ token: string; logged_in_existing_user: boolean }>(
    `/${endpoint}/social/`,
    { ...params }
  );

export const login = (params: IAuthParams) =>
  WebshareApi.post("/login/", { ...params });

export const resetPassword = (params: IResetPasswordParams) =>
  WebshareApi.post("/resetpassword/", { ...params });

export const completeResetPassword = (params: ICompleteResetPasswordParams) =>
  WebshareApi.post<{ token: string }>("/resetpassword/complete/", {
    ...params,
  });

export const activate = (params: { activation_token: string }) =>
  WebshareApi.post("/activation/complete/", { ...params });

export const logout = () => WebshareApi.post("/logout/");

export const changePassword = (params: ChangePasswordParamsType) =>
  WebshareApi.post("/changepassword/", params);

export const changeEmailRequest = (params: ChangeEmailRequestType) =>
  WebshareApi.post("/changeemail/", params);

export const changeEmailCompleteRequest = (params: ChangeEmailConfirmType) =>
  WebshareApi.post("/changeemail/complete/", params);

export const deleteAccount = (params: {
  password: string;
  recaptcha: string;
}) => WebshareApi.post("/deleteaccount/", params);
